import React from "react"
import "./paragraph.css"

export default ({ children }) => <p className="paragraph">{children}</p>
